import { useCurrentUser } from "../../../hooks/useGetUserDetail";
import { PROFILE_TYPE } from "../../../utils/constants";
import "./WebProfile.scss";

function WebProfile() {
  const { data: userInfo, loading } = useCurrentUser();

  const profileType = userInfo?.profileType?.toLowerCase();
  const isSuperAdmin = profileType === PROFILE_TYPE.SUPER_ADMIN;
  const roleLabel = isSuperAdmin ? "Super Admin" : profileType ? "Admin" : "";

  const fullName =
    userInfo?.firstName || userInfo?.lastName
      ? `${userInfo?.firstName || ""} ${userInfo?.lastName || ""}`.trim()
      : userInfo?.name || "—";

  const email = userInfo?.email || "—";
  const school = userInfo?.schoolName || userInfo?.school?.name || "—";

  const initials =
    fullName !== "—"
      ? fullName
          .split(" ")
          .map((n: string) => n[0])
          .join("")
          .slice(0, 2)
          .toUpperCase()
      : "U";

  if (loading) {
    return (
      <div className="web-profile">
        <div className="web-profile__loading">Loading profile…</div>
      </div>
    );
  }

  return (
    <div className="web-profile">
      <h2 className="web-profile__page-title">My Profile</h2>

      <div className="web-profile__card">
        {/* Avatar + name */}
        <div className="web-profile__avatar-section">
          <div className="web-profile__avatar">{initials}</div>
          <div className="web-profile__name-block">
            <h3 className="web-profile__fullname">{fullName}</h3>
            {roleLabel && (
              <span
                className={`web-profile__badge ${
                  isSuperAdmin
                    ? "web-profile__badge--super"
                    : "web-profile__badge--admin"
                }`}
              >
                {roleLabel}
              </span>
            )}
          </div>
        </div>

        <div className="web-profile__divider" />

        {/* Details grid */}
        <div className="web-profile__details">
          <div className="web-profile__detail-row">
            <span className="web-profile__detail-label">Email</span>
            <span className="web-profile__detail-value">{email}</span>
          </div>
          <div className="web-profile__detail-row">
            <span className="web-profile__detail-label">School</span>
            <span className="web-profile__detail-value">{school}</span>
          </div>
          <div className="web-profile__detail-row">
            <span className="web-profile__detail-label">Role</span>
            <span className="web-profile__detail-value">{roleLabel || "—"}</span>
          </div>
          <div className="web-profile__detail-row">
            <span className="web-profile__detail-label">Mode</span>
            <span className="web-profile__detail-value web-profile__detail-value--mode">
              WebApp
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebProfile;
